import { render, staticRenderFns } from "./GetAllPaymentWays.vue?vue&type=template&id=018d3a57&scoped=true&"
import script from "./GetAllPaymentWays.vue?vue&type=script&lang=js&"
export * from "./GetAllPaymentWays.vue?vue&type=script&lang=js&"
import style0 from "./GetAllPaymentWays.vue?vue&type=style&index=0&id=018d3a57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018d3a57",
  null
  
)

export default component.exports